'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRole from "./presto.types$-Role.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Role$() {
}
export { $c_Lpresto_types$Role$ as $c_Lpresto_types$Role$ };
$p = $c_Lpresto_types$Role$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Role$;
/** @constructor */
function $h_Lpresto_types$Role$() {
}
export { $h_Lpresto_types$Role$ as $h_Lpresto_types$Role$ };
$h_Lpresto_types$Role$.prototype = $p;
$p.l = (function() {
  return "Role";
});
$p.nI = (function(x$0) {
  return new $j_presto$002etypes$0024$002dRole.$c_Lpresto_types$Role($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), x$0.j(2), x$0.j(3), x$0.j(4));
});
var $d_Lpresto_types$Role$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Role$, "presto.types$Role$", ({
  a1o: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$Role$ as $d_Lpresto_types$Role$ };
var $n_Lpresto_types$Role$;
function $m_Lpresto_types$Role$() {
  if ((!$n_Lpresto_types$Role$)) {
    $n_Lpresto_types$Role$ = new $c_Lpresto_types$Role$();
  }
  return $n_Lpresto_types$Role$;
}
export { $m_Lpresto_types$Role$ as $m_Lpresto_types$Role$ };
//# sourceMappingURL=presto.types$-Role$.js.map
